import { useEffect, useState } from "react";

export const PageLoader = () => {
  const [progress, setProgress] = useState(0);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const duration = 1500;

    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      setProgress(Math.round(p * 100));
      if (p < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setTimeout(() => setHidden(true), 250);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className={`page-loader ${hidden ? "loader-hidden" : ""}`} data-testid="page-loader">
      <div className="relative w-24 h-24">
        <div className="absolute inset-0 rounded-full border border-[#E8C27A]/30" />
        <div
          className="absolute inset-0 rounded-full bg-gradient-to-br from-[#f6ecd2] to-[#cbb27a]"
          style={{ clipPath: `inset(0 ${100 - progress}% 0 0 round 999px)` }}
        />
      </div>
      <p data-testid="page-loader-percent" className="font-display text-xl gold-gradient-text tracking-widest">
        {progress}%
      </p>
    </div>
  );
};
